import { ConfigService } from './../../../services/config.service';
import { TimerHelper } from './../../../helpers/timer.helper';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SaveFormService } from '../../../services/save-form.service';
import { Subscription } from 'rxjs';
import { QuestionService } from '../../../services/question.service';
import { QuestionType, AdminQuestion } from '../../../models/questions';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-text-form',
  templateUrl: './text-form.component.html',
  styles: [],
})
export class TextFormComponent implements OnInit, OnDestroy {
  @Input() categoryIds: Array<number> = [];
  @Input() questionType: QuestionType;
  @Input() question: AdminQuestion;

  placeholderArray: Array<string> = [];
  subscription: Subscription;
  questionTextForm: FormGroup;
  titlePropertiesArray: Array<string> = [];
  partOfTitleControlName = 'title_';

  private saveClicked: boolean;

  constructor(
    private questionFormBuilder: FormBuilder,
    private saveFormService: SaveFormService,
    private questionService: QuestionService,
    private appData: ConfigService,
    private readonly toastr: ToastrService
  ) {}

  ngOnInit() {
    if (!this.question.id) {
      this.question.answerType = this.questionType;
      this.question.answers = [];
    }
    this.question.categoryIds = this.categoryIds;
    this.createQuestionForm();
    this.saveFormService.addAllLocalizedNameToFormGroup(
      this.questionTextForm,
      this.partOfTitleControlName,
      this.question.localizedNames
    );
    this.saveFormService.addValidationToLocalizedControls(
      this.questionTextForm,
      this.partOfTitleControlName
    );
    this.titlePropertiesArray = this.saveFormService.mapFormGroupControlToPropArray(
      this.questionTextForm,
      this.partOfTitleControlName
    );
    this.placeholderArray = this.saveFormService.setPlaceholderArray(
      this.questionTextForm.controls
    );
    this.questionTextForm.valueChanges.subscribe(() => {
      this.saveFormService.formValueChanged(true);
      this.question.localizedNames = this.saveFormService.mapFormvalueToQuestion(
        this.questionTextForm.value,
        this.partOfTitleControlName
      );
    });
    this.subscription = this.saveFormService.saveButtonClicked$.subscribe(
      (x) => {
        if (x.question.id !== this.question.id) {
          return;
        }
        this.saveTextForm(x.question, x.isAdd);
      }
    );
  }

  createQuestionForm() {
    this.questionTextForm = this.questionFormBuilder.group({});
  }

  canShowFormControlError(formControlName: string): boolean {
    return (
      this.saveClicked &&
      this.saveFormService.canShowFormControlFieldError(
        this.questionTextForm,
        formControlName
      )
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private saveTextForm(question: AdminQuestion, isAdd: boolean) {
    this.showErrorTooltipTimer();
    if (this.questionTextForm.invalid) {
      return;
    }
    this.question.localizedNames = this.saveFormService.mapFormvalueToQuestion(
      this.questionTextForm.value,
      this.partOfTitleControlName
    );
    if (isAdd) {
      this.addQuestion(question);
    } else {
      this.questionService.update(this.question).subscribe(
        () => {
          this.saveFormService.closeForm(this.question);
        },
        (err) => {
          this.toastr.error(err.error, 'Error');
        }
      );
    }
  }

  private showErrorTooltipTimer() {
    this.saveClicked = true;
    TimerHelper.timer(
      this.appData.configData.displayTooltipTimeMilliseconds,
      () => (this.saveClicked = false)
    );
  }

  private addQuestion(question: AdminQuestion) {
    this.question.categoryIds = question.categoryIds;
    this.questionService.create(this.question).subscribe(() => {
      this.saveFormService.closeForm(this.question);
    });
  }
}
